import './BurgerMenu.css';
import logo from '../../assets/logo-no-bg.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faX } from '@fortawesome/free-solid-svg-icons';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import React, { useState } from 'react';

function BurgerMenu({ showMenu, closeMenu }) {

  const [burgerPortfolioOptions, setBurgerPortfolioOptions] = useState(false);

  const handleLinkClick = ({ destination }) => {
    closeMenu();
  };

  const handleBurgerPortfolioOptions = () => {
    setBurgerPortfolioOptions(!burgerPortfolioOptions);
  };

  return (
    <div id="burger" className={showMenu ? 'visible' : ''}>
        <div className="burger-container">
            <ul>
                <li>
                  <a href="#about" onClick={() => handleLinkClick("#about")}>Who We Are</a>
                </li>
                <li className={burgerPortfolioOptions ? 'show-burger-portfolio-options portfolio-burger-item' : 'portfolio-burger-item'}>
                  <a href="#portfolio" onClick={() => handleBurgerPortfolioOptions()}>Our Portfolio <FontAwesomeIcon icon={
                    burgerPortfolioOptions ? faChevronUp : faChevronDown
                  } /></a>
                  <ul className="burger-portfolio-options">
                    <li>
                      <a href="#portfolio" onClick={() => handleLinkClick("#portfolio")}>F&B</a>
                    </li>
                    <li>
                      <a href="/real-estate">Real Estate</a>
                    </li>
                    <li>
                      <a href="#pipeline" onClick={() => handleLinkClick("#pipeline")}>Other Investments</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="/contact" onClick={() => handleLinkClick("#contact")}>Contact Us</a>
                </li>
            </ul>
            <img src={logo} alt="logo" />
            <FontAwesomeIcon icon={faX} className="close" onClick={closeMenu} />
        </div>
    </div>
  );
}

export default BurgerMenu;